import { createStore, action } from 'easy-peasy';

const store = createStore({
	recentSnippets: [],
	addRecentSnippet: action((state, snippet) => {
		console.log(snippet);
		state.recentSnippets.push({ snippetId: snippet });
	})
});

export { store };
